// Careers.js
import React, { useState, useEffect, useRef } from 'react';
import Header from '../Components/Header';
import Footer from './Footer';
import './Careers.css';
import serviceimg1 from '../images/about1.jpeg';

const jobs = [
  {
    id: 'SGTECHSA02',
    client: 'DNY',
    title: 'React.js Developer',
    location: 'Glendale, CA',
    mode: 'Hybrid',
    techStack: 'React.js',
    shortDesc: 'Employment Type: Full Time.',
    fullDescription: (
      <>
        <h3>Job Description:</h3>
        <p>
          We are seeking a skilled React.js Developer with strong expertise in building scalable and responsive web applications.
          The ideal candidate will have experience working with modern JavaScript frameworks, state management, REST/GraphQL APIs,
          and delivering high-quality, user-focused solutions.
        </p>
        <h3>Key Responsibilities:</h3>
        <ul>
          <li>Design and develop responsive web applications using React.js, Redux, and TypeScript/JavaScript.</li>
          <li>Build reusable components and front-end libraries for future use.</li>
          <li>Integrate RESTful and GraphQL APIs with front-end components.</li>
          <li>Collaborate with UI/UX designers to ensure high-quality user experiences.</li>
          <li>Optimize application performance for speed and scalability.</li>
          <li>Troubleshoot, debug, and resolve front-end issues.</li>
          <li>Work with tools like Webpack, Babel, and npm/yarn for efficient builds.</li>
        </ul>
        <h3>Qualifications:</h3>
        <ul>
          <li>Bachelor’s degree in Computer Science, Engineering, or related field.</li>
          <li>3–5+ years of experience in front-end development.</li>
          <li>Strong knowledge of React.js, Redux, JavaScript (ES6+), and TypeScript.</li>
          <li>Experience with HTML5, CSS3, and responsive design principles.</li>
          <li>Familiarity with version control (Git) and CI/CD workflows.</li>
          <li>Experience integrating APIs and working with backend developers.</li>
          <li>Knowledge of testing frameworks like Jest, React Testing Library, or Cypress is a plus.</li>
        </ul>
      </>
    )
  },
  {
    id: 'SGTECHSA01',
    client: 'Financial Services',
    title: 'Desktop Engineer',
    location: 'Santa Ana, Orange County',
    mode: 'On-Site',
    techStack: 'Basic Hardware Knowledge',
    shortDesc: '3 days (8 hours) on-site job',
    fullDescription: (
      <>
        <h3>Job Description:</h3>
        <p>
          A Desktop Engineer is an IT professional responsible for managing, maintaining, and supporting desktop systems, including computers, operating systems, and end-user software, within an organization.
        </p>
        <h3>Key Responsibilities:</h3>
        <ul>
          <li>Installing, configuring, and troubleshooting Windows and macOS desktops/laptops</li>
          <li>Supporting end-user hardware (monitors, printers, peripherals)</li>
          <li>Managing software installations, updates, and patches</li>
          <li>Maintaining asset inventory and documenting configurations</li>
        </ul>
        <h3>Qualifications:</h3>
        <ul>
          <li>Basic knowledge on computer hardware parts</li>
        </ul>
      </>
    )
  },
  {
    id: 'STADPLA03',
    client: 'ADP',
    title: 'Full Stack Developer',
    location: 'Pasadena, LA',
    mode: 'Hybrid',
    techStack: 'Java & Angular',
    shortDesc: 'Java, Angular – Work on backend and frontend apps.',
    fullDescription: (
      <>
        <h3>Job Description:</h3>
        <p>
          We are seeking a highly skilled and experienced Full Stack Developer with a strong emphasis on back-end technologies. The ideal candidate needs to have primary expertise in Java, Spring Boot, RESTful APIs, microservices architecture, and event-driven systems, along with solid experience in front-end technologies such as Angular, React, Stencil, JavaScript, HTML, CSS, and TypeScript. Familiarity with AWS cloud technologies and build tools (npm, Grunt).
        </p>
        <h3>Key Responsibilities:</h3>
        <ul>
          <li>Design, develop, and maintain back-end services with Java, Spring Boot, and microservices architecture.</li>
          <li>Develop robust, high-performance RESTful APIs and event-driven solutions to support scalable applications.</li>
          <li>Collaborate with front-end developers to build interactive UIs using Angular or React, JavaScript, HTML, CSS, and TypeScript.</li>
          <li>Work with AWS cloud services to deploy and manage scalable applications.</li>
          <li>Use build tools like npm and Grunt for efficient development and deployment workflows.</li>
          <li>Collaborate with cross-functional teams to define, design, and deploy new features and enhancements.</li>
          <li>Perform code reviews, and ensure best practices in code quality, architecture, and design.</li>
          <li>Troubleshoot, debug, and resolve application issues, ensuring high performance and responsiveness.</li>
          <li>Stay up-to-date with industry trends and new technologies to improve application performance and scalability.</li>
        </ul>
        <h3>Qualifications:</h3>
        <ul>
          <li>Bachelor’s degree in Computer Science, Software Engineering, or a related field.</li>
          <li>4+ years of experience as a Full Stack Developer, with strong back-end focus.</li>
          <li>Strong expertise in Java and Spring Boot for back-end development.</li>
          <li>Proven experience with RESTful API development, microservices architecture, and event-driven architecture.</li>
          <li>Good proficiency with front-end frameworks and libraries: Stencil (Web Components).</li>
          <li>Hands-on experience with AWS services and cloud deployment strategies.</li>
          <li>Familiarity with CI/CD pipelines and DevOps practices.</li>
          <li>Experience with containerization tools (e.g., Docker) and orchestration tools (e.g., Kubernetes).</li>
          <li>Knowledge of testing frameworks and practices for both front-end and back-end.</li>
          <li>Experience with SQL and NoSQL databases.</li>
          <li>Understanding of version control tools, particularly Git.</li>
          <li>Experience working in an Agile development environment.</li>
          <li>Strong problem-solving skills, with attention to detail and quality.</li>
          <li>Excellent communication and teamwork skills.</li>
        </ul>
      </>
    )
  },
  {
    id: 'STADPLA02',
    client: 'ADP',
    title: 'Frontend Developer',
    location: 'Pasadena, LA',
    mode: 'Hybrid',
    techStack: 'Angular',
    shortDesc: 'Stencil or Angular – Design modern UI components.',
    fullDescription: (
      <>
        <h3>Job Description:</h3>
        <p>
          We are looking for a Frontend Developer skilled in modern UI frameworks such as Angular, React, or Stencil. The candidate will be responsible for developing responsive and performant user interfaces.
        </p>
        <h3>Key Responsibilities:</h3>
        <ul>
          <li>Build modern and responsive web interfaces using Angular, React, or Stencil.</li>
          <li>Collaborate with backend teams to integrate APIs seamlessly into the UI.</li>
          <li>Ensure UI consistency, accessibility, and cross-browser compatibility.</li>
          <li>Use JavaScript, TypeScript, HTML, and CSS effectively for styling and interaction.</li>
          <li>Optimize UI performance and troubleshoot UI bugs and issues.</li>
          <li>Work with build tools such as npm and Grunt.</li>
        </ul>
        <h3>Qualifications:</h3>
        <ul>
          <li>Bachelor’s degree in Computer Science, Design, or related field.</li>
          <li>4+ years of experience in frontend/UI development.</li>
          <li>Proficiency in Angular, React, or Stencil.</li>
          <li>Strong knowledge of JavaScript, HTML, CSS, and TypeScript.</li>
          <li>Experience with version control tools like Git.</li>
          <li>Familiarity with Agile workflows and UI testing frameworks.</li>
        </ul>
      </>
    )
  },
  {
    id: 'STADPLA01',
    client: 'ADP',
    title: 'Backend Developer',
    location: 'Pasadena, LA',
    mode: 'Hybrid',
    techStack: 'Java',
    shortDesc: 'Java 17, Spring Boot, AWS – Build scalable backend services.',
    fullDescription: (
      <>
        <h3>Job Description:</h3>
        <p>
          We are seeking a Backend Developer with strong expertise in Java, Spring Boot, and RESTful API development. The ideal candidate will be experienced in building scalable backend services and microservices, integrating AWS cloud services, and delivering high-quality solutions.
        </p>
        <h3>Key Responsibilities:</h3>
        <ul>
          <li>Design and develop robust, scalable backend services using Java and Spring Boot.</li>
          <li>Develop and maintain RESTful APIs for business logic and integration.</li>
          <li>Work with microservices architecture and event-driven systems.</li>
          <li>Deploy and manage applications using AWS services like Lambda, EC2, S3, and DynamoDB.</li>
          <li>Use build tools like Maven, npm, and Grunt for efficient CI/CD workflows.</li>
          <li>Troubleshoot and resolve backend issues and performance bottlenecks.</li>
        </ul>
        <h3>Qualifications:</h3>
        <ul>
          <li>Bachelor’s degree in Computer Science or related field.</li>
          <li>4+ years of experience in backend development.</li>
          <li>Strong knowledge of Java, Spring Boot, and REST APIs.</li>
          <li>Experience with AWS cloud deployment and services.</li>
          <li>Familiarity with Docker, Kubernetes, and CI/CD pipelines.</li>
          <li>Proficient in working with SQL and NoSQL databases.</li>
        </ul>
      </>
    )
  }
];



const Careers = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [resume, setResume] = useState(null);
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [contact, setContact] = useState('');
  const [openJobIds, setOpenJobIds] = useState([]);
  const [visaType, setVisaType] = useState('');
  const [employmentType, setEmploymentType] = useState('');
  const [salary, setSalary] = useState('');
  const [salaryType, setSalaryType] = useState('');
  const [error, setError] = useState("");
  const [zipCode, setZipCode] = useState('');
  const modalRef = useRef();

  const toggleDescription = (id) => {
    setOpenJobIds((prev) =>
      prev.includes(id) ? prev.filter((jobId) => jobId !== id) : [...prev, id]
    );
  };

  const openModal = (job) => {
    setSelectedJob(job);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedJob(null);
    setVisaType('');
    setResume(null);
    setFullName('');
    setEmail('');
    setContact('');
    setSalary('');
    setSalaryType('');
    setEmploymentType('');
    setZipCode('');
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const extension = file.name.split('.').pop().toLowerCase();
      if (extension !== "pdf") {
        setError("Please upload a PDF file.");
        e.target.value = null;
      } else {
        setResume(file);
        setError("");
      }
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        closeModal();
      }
    };

    if (isModalOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isModalOpen]);

  return (
    <>
      <Header />
      <div className="hero" style={{ backgroundImage: `url(${serviceimg1})` }}>
        <div className="hero-content-wrapper">
          <h1 style={{ fontSize: '50px', color: 'white', fontWeight: 'bold', marginTop: 'revert', fontFamily: 'Arial, sans-serif' }} className="hero-heading">Job openings</h1>

          <button
            className="talent-pool-btn"
            onClick={() =>
              openModal({
                id: 'TalentPool',
                title: 'Join Talent Pool',
                techStack: '',
                location: '',
              })
            }
          >
            Join Talent Pool
          </button>
        </div>
      </div>
      {/* <div className="main-content">
                <div className="hero" style={{ backgroundImage: `url(${serviceimg1})` }}>
                    <div className="hero-content">
                        
                        <h1 style={{fontSize:'55px',color:'white',fontWeight:'bold', marginTop:'revert', fontFamily: 'Arial, sans-serif' }}>Job openings</h1>
                    </div>
                    
  <button
    className="talent-pool-btn"
    onClick={() =>
      openModal({
        id: 'TalentPool',
        title: 'Join Talent Pool',
        techStack: '',
        location: 'N/A',
      })
    }
  >
    Join Talent Pool
  </button>
</div>
               */}
      {/* </div> */}

      <div className="careers-container">
        <div className="job-openings-grid">
          {jobs.map((job) => (
            <div key={job.id} className="job-card">
              <h2>{job.title} ({job.techStack})</h2>
              <p><strong>Client:</strong> {job.client}</p>
              <p><strong>Job ID:</strong> {job.id}</p>
              <p><strong>Location:</strong> {job.location}</p>
              <p><strong>Mode:</strong> {job.mode}</p>
              <p>{job.shortDesc}</p>
              {openJobIds.includes(job.id) ? (
                <>
                  <p
                    style={{ color: 'Red', cursor: 'pointer', fontWeight: 'bold' }}
                    onClick={() => toggleDescription(job.id)}
                  >
                    ▼ Hide Full Description
                  </p>
                  <div>{job.fullDescription}</div>
                </>
              ) : (
                <p
                  style={{ color: 'Red', cursor: 'pointer', fontWeight: 'bold' }}
                  onClick={() => toggleDescription(job.id)}
                >
                  ► View Full Description
                </p>
              )}
              <button className="apply-button" onClick={() => openModal(job)}>Apply →</button>
            </div>
          ))}
        </div>

        {/* 🔹 Bottom Join Talent Pool */}
        <div className="bottom-talent-pool">
          <p>
            Didn’t find a match?{" "}
            <span
              style={{ color: "blue", cursor: "pointer", fontWeight: "bold" }}
              onClick={() =>
                openModal({
                  id: "TalentPool",
                  title: "Join Talent Pool",
                  techStack: "",
                  location: "N/A",
                })
              }
            >
              Join our Talent Pool
            </span>
          </p>
        </div>
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content" ref={modalRef}>
            <button className="close-button" onClick={closeModal}>X</button>
            <button className="close-button" onClick={closeModal}>X</button>

            <button className="close-button" onClick={closeModal}>X</button>

            <h2>
              {selectedJob.title}
              {selectedJob.techStack && ` (${selectedJob.techStack})`}
            </h2>
            {selectedJob.id !== 'TalentPool' && <p>📍 {selectedJob.location}</p>}

            {/* Form */}
            <form
              className="apply-form"
              onSubmit={async (e) => {
                e.preventDefault();
                const formData = new FormData();
                formData.append('fullName', fullName);
                formData.append('email', email);
                formData.append('contact', contact);
                formData.append('jobTitle', selectedJob.title);
                formData.append('jobId', selectedJob.id);
                formData.append('resume', resume);
                formData.append('visaType', visaType);
                formData.append('employmentType', employmentType);
                formData.append('salary', salary);
                formData.append('salaryType', salaryType);
                formData.append('zipCode', zipCode);

                try {
                  const JOB_API_URL = 'https://globalsgtech.com/api/api/job-application';
                  const response = await fetch(JOB_API_URL, {
                    method: 'POST',
                    body: formData
                  });

                  const result = await response.json();
                  if (response.ok) {
                    alert('Application submitted successfully!');
                    closeModal();
                  } else {
                    alert('Submission failed: ' + result.message);
                  }
                } catch (err) {
                  console.error('Error submitting job application:', err);
                  alert('Something went wrong!');
                }
              }}
            >
              <label>Full Name*</label>
              <input type="text" value={fullName} onChange={(e) => setFullName(e.target.value)} required />

              <label>Email*</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />

              <label>Contact Number*</label>
              <input type="tel" value={contact} onChange={(e) => setContact(e.target.value)} required />

              <label>Visa Type*</label>
              <select value={visaType} onChange={(e) => setVisaType(e.target.value)} required>
                <option value="">Select Visa Type</option>
                <option value="Citizen">U.S. Citizen</option>
                <option value="Green Card">Green Card</option>
                <option value="H1B">H1B</option>
                <option value="OPT">OPT</option>
                <option value="CPT">CPT</option>
                <option value="H4 EAD">H4 EAD</option>
                <option value="L2 EAD">L2 EAD</option>
                <option value="TPS">TPS</option>
                <option value="Other">Other (Specify in Resume)</option>
              </select>

              <label>Employment Type*</label>
              <select value={employmentType} onChange={(e) => setEmploymentType(e.target.value)} required>
                <option value="">Select Employment Type</option>
                <option value="Full-time">Full-time</option>
                <option value="Contract">Contract</option>
              </select>

              <label>Expected Salary*</label>
              <div className="salary-row">
                <input
                  type="number"
                  value={salary}
                  onChange={(e) => setSalary(e.target.value)}
                  required
                />
                <select
                  value={salaryType}
                  onChange={(e) => setSalaryType(e.target.value)}
                  required
                >
                  <option value="">Select Type</option>
                  <option value="per annum">Per Annum</option>
                  <option value="per hour">Per Hour</option>
                </select>
              </div>

              <label>ZIP Code*</label>
              <input type="text" value={zipCode} onChange={(e) => setZipCode(e.target.value)} required />

              <label>Upload Resume (PDF only)*</label>
              <input type="file" onChange={handleFileChange} required />

              <button type="submit" className="submit-btn">Apply Now</button>
              {error && <p style={{ color: 'red' }}>{error}</p>}
            </form>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
};

export default Careers;
